import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import PaymentLink from './pages/PaymentLink';
import FirstPayment from './pages/FirstPayment';
import LanguageContext from './contexts/LanguageContext';
import './styles/App.css';
//import { captureConsoleLogs } from './logger';
//import FlywirePaymentForm from 'pages/TestFlywire';
import PageInterview from 'pages/PaymentInterview';

import { 
  REACT_APP_COUNTRY_DEPLOY
} from '../src/config';

function App() {
  
  return (
      <Router>
        <AppContent />
      </Router>
  );
}

function AppContent() {
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const languageMap: { [key: string]: string } = {
        EN: 'en',
        ES: 'es',
        PT: 'pt',
    };
    const reverseLanguageMap: { [key: string]: string } = {
        'en': 'EN',
        'es': 'ES',
        'pt': 'PT',
    };
    const DEFAULT_LANGUAGE = REACT_APP_COUNTRY_DEPLOY === 'BR' ? 'pt' : 'es';
    
    // Aplicar lógica de query param lang
    const langParam = queryParams.get('lang');
    const hasLangQueryParam = langParam !== null && ['EN', 'ES', 'PT'].includes(langParam.toUpperCase());
    const lang = hasLangQueryParam ? langParam : null;
    
    const [selectedLanguage, setSelectedLanguage] = useState<string>(
      lang ? (languageMap[lang.toUpperCase()] || DEFAULT_LANGUAGE) : DEFAULT_LANGUAGE
    );
    const [isLanguageFromUrl, setIsLanguageFromUrl] = useState<boolean>(hasLangQueryParam);
  
    const changeLanguage = (newLanguage: string, forceChange: boolean = false) => {
      // Si forceChange es true (cambio desde el selector), permitir el cambio y actualizar URL
      if (forceChange) {
        setSelectedLanguage(newLanguage);
        setIsLanguageFromUrl(true);
        
        // Actualizar el query param lang en la URL
        const newQueryParams = new URLSearchParams(location.search);
        const langCode = reverseLanguageMap[newLanguage] || 'ES';
        newQueryParams.set('lang', langCode);
        
        navigate(`${location.pathname}?${newQueryParams.toString()}`, { replace: true });
        return;
      }
      
      // Si no viene de la URL, permitir el cambio normalmente
      if (!isLanguageFromUrl) {
        setSelectedLanguage(newLanguage);
      }
    };
  
    /*useEffect(() => {
      captureConsoleLogs();
    }, []);*/

    return (
      <LanguageContext.Provider value={{ language: selectedLanguage, changeLanguage, isLanguageFromUrl }}>
        <div className="App">
          <Routes>
            <Route path="/" element={<FirstPayment language={selectedLanguage || DEFAULT_LANGUAGE} region={REACT_APP_COUNTRY_DEPLOY}/>} />
            <Route path="/link" element={<PaymentLink language={selectedLanguage || DEFAULT_LANGUAGE} region={REACT_APP_COUNTRY_DEPLOY} />} />
            <Route path="/confirmation" element={<PageInterview/>} />
            {/*<Route path="/BR/" element={<FirstPayment language={selectedLanguage || 'pt'} region='BR'/>} />
            <Route path="/BR/link" element={<PaymentLink language={selectedLanguage || 'pt'} region='BR'/>} />
            <Route path="/BR/confirmation" element={<PageInterview/>} />
            <Route path="/MX/" element={<FirstPayment language={selectedLanguage || 'es'} region='MX'/>} />
            <Route path="/MX/link" element={<PaymentLink language={selectedLanguage || 'es'} region='MX'/>} />
            <Route path="/MX/confirmation" element={<PageInterview/>} />
            <Route path="/test-flywire" element={<FlywirePaymentForm/>} />*/}
          </Routes>
        </div>
      </LanguageContext.Provider>
    );
}

export default App;